module.exports = __webpack_public_path__ + "img/CellCycle-ASHN_GSE227469.1b887179.png";